import React from 'react'
import BackHandler from '../components/BackHandler'

const Result = () => {
  BackHandler();
  return (
    <div>Result</div>
  )
}

export default Result
